import { GridItem } from '@calendly/ui/components/grid'

export const LeftColumn = ({ children }) => (
  <GridItem size="3" sizeMobile="12">
    {children}
  </GridItem>
)
